import React, {Component} from "react";
import API from "../config/api";
import axios from "axios";

class Error404 extends Component {

    UNSAFE_componentWillMount() {
        this.updateBuild()
    }
  async updateBuild() {
    try {
        const items = JSON.parse(localStorage.getItem('login'));
    let result = await axios.get(
        `https://dev.ubtcambodia.com/admin/backend/gitpull`, 
        // { headers: { token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkYXRhIjp7InVzZXJfaWQiOjEsInBhc3N3b3JkX2xldmVsIjoxfSwiaWF0IjoxNzE5OTgxNjQ1fQ.6cZfF5rM-p5Dnh_V7IHf60YU1PHKx45-j6BXx_W6d7c" }}
        { headers: { token: items.data.token }}
    );

    console.log(result)
    } catch (error) {
        console.log(error)
    }
  }

  render() {
    return (
        <div class="col-12" style={{paddingTop: "10%"}}>

            <form className="card" >
                <button >Success</button>
            </form>
    </div>
    );    
  }
}

export default Error404;
